<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center" color="blue-grey" dark>
          所属者一覧({{ groupName }})
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="mt-1 pt-2">
      <v-col cols="12" sm="2" xs="4" justify="center">
        <v-select
          label="課程"
          :items="kateiMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedKatei"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="2" xs="4" justify="center">
        <v-select
          label="部"
          :items="buMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedBu"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="12" sm="3" xs="4" justify="center">
        <v-select
          label="科"
          :items="kaMst"
          @change="changeKBK"
          item-text="name"
          item-value="code"
          v-model="selectedKa"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="5" sm="2" xs="5" justify="center">
        <v-select
          label="学年"
          :items="gakunenMst"
          item-text="name"
          item-value="code"
          v-model="selectedGakunen"
          outlined
          dense
          clearable
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="5" sm="2" xs="5" justify="center">
        <v-select
          label="学級"
          :items="gakkyuMst"
          item-text="name"
          item-value="code"
          v-model="selectedGakkyu"
          outlined
          dense
          clearable
          multiple
          chips
          deletable-chips
          hide-details="auto"
          background-color="white"
          ></v-select>
      </v-col>
      <v-col cols="2" sm="1" xs="2" justify="center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="mt-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
          </template>
          <div>課程・部・科・学年・学級は</div>
          <div>生徒・保護者を絞り込むための条件です</div>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" sm="4" xs="6">
        <!-- 検索用のテキスト入力 -->
        <v-text-field
          v-model="search"
          label="氏名ｶﾅ検索"
          placeholder="氏名ｶﾅ検索"
          clearable
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="4" xs="6">
        <v-text-field
          v-model="searchGakusekiCd"
          label="学籍番号検索"
          placeholder="学籍番号検索"
          clearable
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-tabs class="mx-2 mt-2"
        v-model="tabSelect"
        fixed-tabs
        next-icon="mdi-arrow-right-bold-box-outline"
        prev-icon="mdi-arrow-left-bold-box-outline"
        show-arrows>
        <v-tab :disabled="!viewTab1" href="#students">
          生徒
        </v-tab>
        <v-tab :disabled="!viewTab2" href="#parents">
          保護者
        </v-tab>
        <v-tab :disabled="!viewTab3" href="#teachers">
          教職員
        </v-tab>

        <v-tab-item value="students">
          <v-col cols="12">
            <v-data-table
              :headers="studentHed"
              :items="filterStudents"
              :items-per-page="-1"
              :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
              :loading="isListLoding"
              dense
              :search="search"
              :custom-filter="filter"
              loading-text="読込中">
            </v-data-table>
          </v-col>
        </v-tab-item>
        <v-tab-item value="parents">
          <v-col cols="12">
            <v-data-table
              :headers="parentsHed"
              :items="filterParents"
              :items-per-page="-1"
              :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
              :loading="isListLoding"
              dense
              :search="search"
              :custom-filter="filter"
              loading-text="読込中">
              <template #[`item.students`]="{ item }">
                <v-row dense v-for="student in item.studentsInfo" :key="student.loginId" >
                  <v-col cols="12" justify="center">
                    {{ student.userNm }}/{{ student.kateiNm }}/{{ student.buNm }}/{{ student.kaNm }}/{{ student.gakunen }}/{{ student.gakkyu }}/{{ student.syussekiNo }} ({{ student.gakusekiCd }})
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-tab-item>
        <v-tab-item value="teachers">
          <v-col cols="12">
            <v-data-table
              :headers="teacherHed"
              :items="teachers"
              :items-per-page="-1"
              :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
              :loading="isListLoding"
              dense
              :search="search"
              :custom-filter="filter"
              loading-text="読込中">
            </v-data-table>
          </v-col>
        </v-tab-item>
      </v-tabs>
    </v-row>
    <v-row class="justify-start" dense>
      <v-col>
        <v-btn @click="onClicktoBack" color="grey" class="black--text" width="352">戻る</v-btn>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
export default {
  props: ['groupId','groupName','beforeName'],
  computed: {
    filterStudents() {
      return this.students.filter(s => {
        let kateiMatch = true;
        if(this.selectedKatei && s.kateiCd) {
          kateiMatch = (this.selectedKatei == s.kateiCd);
        }
        let buMatch = true;
        if(this.selectedBu && s.buCd) {
          buMatch = (this.selectedBu == s.buCd);
        }
        let kaMatch = true;
        if(this.selectedKa && s.kaCd) {
          kaMatch = (this.selectedKa == s.kaCd);
        }
        let gakunenMatch = true;
        if(this.selectedGakunen.length > 0 && s.gakunenCd) {
          var gakunenCd = [];
          for (var i=0; i<this.selectedGakunen.length; i++) {
            gakunenCd.push(this.selectedGakunen[i].split("-")[3]);
          }
          gakunenMatch = gakunenCd.includes(s.gakunenCd);
        }
        let gakkyuMatch = true;
        if(this.selectedGakkyu.length > 0 && s.gakkyuCd) {
          var gakkyuCd = [];
          for (var j=0; j<this.selectedGakkyu.length; j++) {
            gakkyuCd.push(this.selectedGakkyu[j].split("-")[3]);
          }
          gakkyuMatch = gakkyuCd.includes(s.gakkyuCd);
        }
        let nameMatch = true;
        if(this.search && s.userNmKana) {
          nameMatch = (s.userNmKana.toString().includes(this.search))
        }
        let gakusekiMatch = true;
        if(this.searchGakusekiCd && s.gakusekiCd) {
          gakusekiMatch = (this.searchGakusekiCd == s.gakusekiCd);
        }
        return kateiMatch && buMatch && kaMatch && gakunenMatch && gakkyuMatch && nameMatch && gakusekiMatch;
      })
    },
    filterParents() {
      return this.parents
        .map(p => {
        const filteredStudents = Array.isArray(p.studentsInfo)
          ? p.studentsInfo.filter(s => {
              const kateiMatch = !this.selectedKatei || s.kateiCd === this.selectedKatei
              const buMatch = !this.selectedBu || s.buCd === this.selectedBu
              const kaMatch = !this.selectedKa || s.kaCd === this.selectedKa
              const gakunenMatch =
                this.selectedGakunen.length == 0 ||
                this.selectedGakunen
                  .map(g => g.split("-")[3])
                  .includes(s.gakunenCd)
              const gakkyuMatch =
                this.selectedGakkyu.length == 0 ||
                this.selectedGakkyu
                  .map(g => g.split("-")[3])
                  .includes(s.gakkyuCd)
              const gakisekiMatch = !this.searchGakusekiCd || s.gakusekiCd === this.searchGakusekiCd

              return kateiMatch && buMatch && kaMatch && gakunenMatch && gakkyuMatch && gakisekiMatch;
            })
          : []

          // studentsInfo を絞り込んだ親オブジェクトを返す
          return { ...p, studentsInfo: filteredStudents }
        })
        // 次に親をフィルタ：studentsInfo が空なら除外
        .filter(p => p.studentsInfo.length > 0)
    }
  },
  data() {
    return {
      kateiMst: [],
      buMst: [],
      kaMst: [],
      gakunenMst: [],
      gakunenMstBase: [],
      gakkyuMst: [],
      gakkyuMstBase: [],
      selectedKatei: "",
      selectedBu: "",
      selectedKa: "",
      selectedGakunen: [],
      selectedGakkyu: "",
      searchGakusekiCd: "",
      search: "",
      selectedUserKbn: [],
      userKbns: [
        { code: "0", name: "生徒" },
        { code: "1", name: "保護者" },
        { code: "8", name: "教員" },
      ],
      studentHed: [
        { text: "氏名", value: "userNm", align: "start"},
        { text: "氏名(ｶﾅ)", value: "userNmKana", align: "start"},
        { text: "課程", value: "kateiNm" },
        { text: "部", value: "buNm" },
        { text: "科", value: "kaNm" },
        { text: "学年", value: "gakunen" },
        { text: "学級", value: "gakkyu" },
        { text: "出席番号", value: "syussekiNo" },
        { text: "学籍番号", value: "gakusekiCd" },
      ],
      students: [],
      parentsHed: [
        { text: "生徒氏名/課程/部/科/学年/学級/出席番号(学籍番号)", value: "students" },
        { text: "保護者氏名", value: "userNm", align: "start"},
        { text: "保護者氏名(ｶﾅ)", value: "userNmKana", align: "start"},
      ],
      parents: [],
      teacherHed: [
        { text: "氏名", value: "userNm", align: "start"},
        { text: "氏名(ｶﾅ)", value: "userNmKana", align: "start"},
      ],
      teachers: [],
      isListLoding: false,
      viewTab1 : false,
      viewTab2 : false,
      viewTab3 : false,
      tabSelect : "",
    };
  },
  // 初期表示時データ読み込み
  async created() {
    this.reload();

    // 課程・部・科・学年・学級の取得
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
    schoolAidHomeLogined({funcName: "commonGetKBKG"}).then((ret) => {
      this.kateiMst = ret.data.kateiMst;
      this.buMst = ret.data.buMst;
      this.kaMst = ret.data.kaMst;
      this.gakunenMstBase = ret.data.gakunenMst;
      this.gakkyuMstBase = ret.data.gakkyuMst;
      if (this.kateiMst.length == 1) {
        this.selectedKatei = this.kateiMst[0].code;
      }
      if (this.buMst.length == 1) {
        this.selectedBu = this.buMst[0].code;
      }
      if (this.kaMst.length == 1) {
        this.selectedKa = this.kaMst[0].code;
      }
    });
  },
  methods: {
		// 課程・部・科設定後のセレクトボックス変更
    async changeKBK() {
      console.log(this.selectedKatei);
      console.log(this.selectedBu);
      console.log(this.selectedKa);
      this.gakunenMst = [];
      this.gakkyuMst = [];
      this.selectedGakkyu = [];
      this.selectedGakunen = [];
      if(this.selectedKatei
       && this.selectedBu
       && this.selectedKa){
        // 学年マスタをKBKでフィルタ
        this.gakunenMst = Enumerable.from(this.gakunenMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
        // 学級マスタをKBKでフィルタ
        this.gakkyuMst = Enumerable.from(this.gakkyuMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
      }
    },
    // 氏名カナ検索
    filter(value, search, item) {
      if(!item.userNmKana)return false;
      return item.userNmKana.toString().includes(search)
    },
    async reload(){
      this.viewTab1 = true;
      this.viewTab2 = true;
      this.viewTab3 = true;
      this.students = [];
      this.parents = [];
      this.teachers = [];
      this.tabSelect = "";

      const data = {
        funcName: "loadGroupMemberList",
        groupId: this.groupId,
      };
      
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isListLoding = true;
      await schoolAidHomeLogined(data).then((ret) => {
        console.log(ret);
        this.viewTab1 = false;
        this.viewTab2 = false;
        this.viewTab3 = false;
        this.students = ret.data.students;
        this.parents = ret.data.parents;
        this.teachers = ret.data.teachers;
        if(this.teachers.length > 0){
          this.viewTab3 = true;
          this.tabSelect = "teachers";
        }
        if(this.parents.length > 0){
          this.viewTab2 = true;
          this.tabSelect = "parents";
        }
        if(this.students.length > 0){
          this.viewTab1 = true;
          this.tabSelect = "students";
        }
        this.isListLoding = false;
      });
    },
    // 戻るボタン
    onClicktoBack(){
      this.$router.push({
        name: this.beforeName
      });
    },
  },
};
</script>